export default __webpack_public_path__ + "static/media/Grandeur_large_14.ef945f51.jpg";